import { useMutation, UseMutationOption } from 'src/hooks/use-mutation'
import { EnablePatientDocument, GqlError } from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

const enablePatient = async ({
  patientUid,
  reason,
}: {
  patientUid: string
  reason: string
}): Promise<void> => {
  try {
    await graphqlRequest(EnablePatientDocument, {
      input: {
        patientUid,
        reason,
      },
    })
  } catch (error) {
    throw error
  }
}

export const useEnablePatient = (
  option?: UseMutationOption<void, GqlError>,
) => {
  return useMutation(
    ({ patientUid, reason }: { patientUid: string; reason: string }) =>
      enablePatient({ patientUid, reason }),
    option,
  )
}
